/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ModuleManifest } from "shared/bootstrap";
import store from "modules/manuals/store";
import publicLocale from "./i18n/public.json";
import adminLocale from "./i18n/admin.json";

const manifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "manuals" },
      title: "manuals.menuItems.manuals",
      icon: "book",
      hideNoAuth: true,
    },
  ],
  routes: [
    {
      path: "/handleidingen",
      name: "manuals",
      meta: {
        auth: true,
        title: "manuals.menuItems.manuals",
      },
      component: () => import("./pages/Manuals.vue"),
    },
  ],
  storeModules: {
    manual: store,
  },
  localisation: { key: "manuals", messages: publicLocale },
};

export default manifest;

export const AdminManifest = {
  menuItems: [
    {
      to: { name: "manuals" },
      title: "manuals.menuItems.manuals",
      icon: "book",
    },
  ],
  routes: [
    {
      path: "/handleidingen",
      name: "manuals",
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      component: () => import("./pages/Manuals.vue"),
      meta: {
        editMode: true,
        title: "manuals.menuItems.manuals",
      },
    },
  ],
  storeModules: {
    manual: store,
  },
  localisation: { key: "manuals", messages: adminLocale },
};
